import { Form } from "@/components/organisms/Form";
import { request } from "@/common/api";
import { Buttons } from "@/components/atoms/Buttons";
import { useState } from "react";
import { InputText } from "@/components/atoms/Inputs/InputText";
import { useNavigate } from "react-router";
import { useMutation } from "@tanstack/react-query";
import { BaseResponse } from "@/common/types/baseRespones";
import { MainTemplate } from "@/components/templates/MainTemplate";
import { ModalConfirm } from "@/components/organisms/Modals/ModalConfirm";
import { InputTextarea } from "@/components/atoms/Inputs/InputTextarea";
import { useRecoilValue } from "recoil";
import { ReactComponent as IconArrow } from "@/styles/assets/svg/icon_arrow.svg";
import {
  loginTypeState,
  studentUserState,
  guardianUserState,
} from "@/common/states/user";

export const InquiryContactWritePage = () => {
  /** 🛣️ Navigation Capability Acquisition */
  const navigate = useNavigate();

  /** 📦 State Store */
  const student = useRecoilValue(studentUserState);
  const guardian = useRecoilValue(guardianUserState);
  const loginType = useRecoilValue(loginTypeState);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [modalShow, setModalShow] = useState(false);

  /** 📡 API Layer */
  // 1:1 문의 작성
  const { mutateAsync: sendInquiry } = useMutation({
    mutationFn: (data: {
      title: string;
      content: string;
      createdByName: string;
      createdBy: string;
    }) => {
      return request<BaseResponse>({
        method: "POST",
        url: "/inquiry/contact",
        data: data,
      });
    },
    onSuccess: () => {
      navigate("/setting/inquiry/contacts");
    },
    onError: (error) => {
      console.error("문의 등록 실패:", error);
    },
  });

  /** 🚀 Action Handlers */
  const handleSubmit = async () => {
    try {
      await sendInquiry({
        title: title,
        content: content,
        createdByName: loginType === "student" ? student.name : guardian.name,
        createdBy: loginType === "student" ? student.id : guardian.id,
      });
      setModalShow(false);
    } catch (error) {
      console.error("에러 발생:", error);
    }
  };

  return (
    <MainTemplate
      nav={false}
      subPage={true}
      menuBtn={false}
      pageTitle="1:1문의 작성"
      buttonLeft={
        <Buttons
          type="button"
          size="headerTextIcon"
          layout="text"
          color="bright100"
          icon={<IconArrow />}
          label="뒤로"
          onClick={() => navigate("/setting/inquiry/contacts")}
        />
      }
    >
      <Form
        onSubmit={handleSubmit}
        submitBtn={
          <Buttons
            type="button"
            size="lg"
            layout="solid"
            color="primary100"
            label="문의 등록"
            onClick={() => setModalShow(true)}
            // disabled={isPending}
          />
        }
        backBtn={
          <Buttons
            type="button"
            size="lg"
            layout="text"
            color="primary100"
            label="취소"
            onClick={() => window.history.back()}
          />
        }
      >
        <>
          <InputText
            id="title"
            label="제목"
            placeholder="제목을 입력하세요."
            onChange={(e) => setTitle(e.target.value)}
          />

          <InputTextarea
            id="content"
            label="내용"
            name="content"
            placeholder="문의 내용을 작성해 주세요."
            onChange={(e) => setContent(e.target.value)}
          />

          {modalShow && (
            <ModalConfirm
              setModalShow={setModalShow}
              onConfirm={handleSubmit}
            />
          )}
        </>
      </Form>
    </MainTemplate>
  );
};
